import React from 'react'

const Headline = () => (
  <div className="headline">
    <h1>
      Do you want more traffic?
    </h1>
    <h2>
      Our team of experts can optimize your website for search engines.
    </h2>
  </div>
)

export default Headline


// WEBPACK FOOTER //
// ./src/components/homepage/headline.js